import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-460e065a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = {
  key: 0,
  class: "badge"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Converstions", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "monogram" }
const _hoisted_7 = { class: "friend_name" }
const _hoisted_8 = {
  key: 0,
  class: "no_friend_msg"
}

import HomeIcon from "@/components/Icons/HomeIcon.vue";
import FriendIcon from "@/components/Icons/FriendIcon.vue";
import SettingsIcon from "@/components/Icons/SettingsIcon.vue";
import LogoIcon from "@/components/Icons/LogoIcon.vue";
import router from "@/router";
import { ComputedRef, computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useStore } from "vuex";

// Types
type Friendship = {
  friendship_id: string;
  user: {
    user_id: string;
    name: string;
    avatar?: string;
  };
};

// Vuex

export default /*#__PURE__*/_defineComponent({
  __name: 'MainSidebar',
  setup(__props) {

// Imports
const store = useStore();
const currentFriends: ComputedRef<Friendship[]> = computed(
  () => store.state.friends.current
);
const incomingFriends: ComputedRef<Friendship[]> = computed(
  () => store.state.friends.incoming
);

const current_user_id: ComputedRef<string> = computed(
  () => router.currentRoute.value.params?.user_id as string
);

// Props/Reactive Variables/Refs
const overview = ref<HTMLButtonElement | null>(null);
const friends = ref<HTMLButtonElement | null>(null);
const settings = ref<HTMLButtonElement | null>(null);

const wsUrl = process.env.VUE_APP_WS_URL as string;
const socket = new WebSocket(wsUrl);

socket.onopen = () => {
  console.log("Connected to Hey's real-time event server");
};

socket.onmessage = (e) => {
  const { event, data } = JSON.parse(e.data);

  if (event == "FRIENDSHIP_DELETED") {
    store.dispatch("deleteFriendship", data);
  } else if (event == "FRIENDSHIP_ACCEPTED") {
    store.dispatch("approveFriendship", data);
  } else if (event == "NEW_INCOMING_FRIENDSHIP") {
    store.dispatch("createNewIncomingFriendship", data);
  } else if (event == "NEW_MESSAGE") {
    // Display notification IF user isn't already reading messages
    if (current_user_id.value != data.sent_by) {
      // Get name of person sending message
      const senderName = currentFriends.value.find(
        (friend) => friend.user.user_id == data.sent_by
      )?.user.name;

      // Create notification
      store.dispatch("newNotif", {
        title: "New Message",
        subtitle: senderName,
        text: data.message,
      });
    }

    // Add received message to list of current messages
    if (router.currentRoute.value.name == "Messages") {
      store.state.current_messages.unshift(data);
    }
  }
};

// Lifecycle Hooks
onBeforeUnmount(() => {
  socket.close();
});

onMounted(async () => {
  const currentRoute = router.currentRoute.value.name;

  document.title = `${String(currentRoute)} | Hey`;

  if (currentRoute == "Overview") {
    overview.value?.classList.add("selected");
  } else if (currentRoute == "Friends") {
    friends.value?.classList.add("selected");
  } else if (currentRoute == "Settings") {
    settings.value?.classList.add("selected");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LogoIcon, { class: "logo" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        ref_key: "overview",
        ref: overview,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/overview')))
      }, [
        _createVNode(HomeIcon),
        _createTextVNode(" Home")
      ], 512),
      _createElementVNode("button", {
        ref_key: "friends",
        ref: friends,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/friends')))
      }, [
        _createVNode(FriendIcon),
        _createTextVNode("Friends "),
        (incomingFriends.value.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(incomingFriends.value.length), 1))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("button", {
        ref_key: "settings",
        ref: settings,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/settings')))
      }, [
        _createVNode(SettingsIcon),
        _createTextVNode("Settings ")
      ], 512),
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFriends.value, (friend) => {
        return (_openBlock(), _createElementBlock("button", {
          key: friend.friendship_id,
          onClick: ($event: any) => (_unref(router).push(`/messages/${friend.user.user_id}`)),
          class: _normalizeClass(['friend', current_user_id.value == friend.user.user_id ? 'selected' : ''])
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(friend.user.name.slice(0, 1).toUpperCase()), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(friend.user.name), 1)
        ], 10, _hoisted_5))
      }), 128)),
      (!currentFriends.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Add Friends To Start Having Conversations. "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})